import { NotificationModalController } from "@/components/Modal/Notification/NotificationModalController";

export default function useNotificationModal(modalStore) {
    const modalController = modalStore.methods.getModalController();
    if (modalController.notificationModal == null) {
        modalController.setNotificationModal(new NotificationModalController())
    }

    const notificationModal = modalController.notificationModal

    return {
        notificationModal
    }
}
